// ShowScrollbar.js

const showScrollbar = () => {
  document.documentElement.style.scrollbarWidth = '';
  document.body.style.scrollbarWidth = '';
  document.documentElement.style.removeProperty('--scrollbar-display');
};

export default showScrollbar;
